export default __webpack_public_path__ + "static/sankey-47453d6a71941b7796a372c7a5367fdb.png";